import { gql } from '@apollo/client';

export const mutation = gql`
  mutation UpdatePlaybookDisabled($id: uuid!, $disabledAt: timestamptz, $disabledNote: String) {
    update_playbooks_by_pk(pk_columns: { id: $id }, _set: { disabledAt: $disabledAt, disabledNote: $disabledNote }) {
      id
      disabledAt
      disabledNote
      disabledBy {
        name
        email
      }
    }
  }
`;

export function buildVariables({ playbookId, disabled, disabledNote }) {
  if (!disabled) {
    return { id: playbookId, disabledAt: null, disabledNote: null };
  }

  return {
    id: playbookId,
    disabledAt: 'now()',
    disabledNote: disabledNote ?? null,
  };
}
